module.exports = __webpack_public_path__ + "static/img/掘进机上作业系安全绳识别.9810375f.png";